define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function firstNumber() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var arg = args_1[_a];
            if (typeof arg === 'number' && !isNaN(arg)) {
                return arg;
            }
        }
        return undefined;
    }
    exports.firstNumber = firstNumber;
    function valAsNumber(val) {
        if (typeof val === 'number' && !isNaN(val)) {
            return val;
        }
        if (typeof val === 'string') {
            var num = parseFloat(val);
            if (!isNaN(num)) {
                return num;
            }
        }
    }
    exports.valAsNumber = valAsNumber;
    function extractFieldAsDecimal($fld) {
        var val = $fld.data('decimal');
        var dval = valAsNumber(val);
        return dval !== undefined ? dval : valAsNumber($fld.val());
    }
    exports.extractFieldAsDecimal = extractFieldAsDecimal;
    function setFieldNumberVal($fld, val) {
        if (typeof val === 'number' && !isNaN(val)) {
            return $fld.data('decimal', val).val(val);
        }
        return $fld;
    }
    exports.setFieldNumberVal = setFieldNumberVal;
    function unsetNumberVal($fld) {
        $fld.val(undefined).removeData('decimal');
        return $fld;
    }
    exports.unsetNumberVal = unsetNumberVal;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/number.js
// module id = 45
// module chunks = 0